/**
 * Labels for property-management merchants vs default dealer wording.
 * Prefer account.platform_type when present (per DB); fall back to merchant.platform_type.
 */

export const PROPERTY_PLATFORM = 'property'

export function resolvePlatformType(account, merchant) {
  const fromAccount = account?.platform_type
  if (
    fromAccount !== undefined &&
    fromAccount !== null &&
    String(fromAccount).trim() !== ''
  ) {
    return String(fromAccount)
  }
  const fromMerchant = merchant?.platform_type
  if (
    fromMerchant !== undefined &&
    fromMerchant !== null &&
    String(fromMerchant).trim() !== ''
  ) {
    return String(fromMerchant)
  }

  return 'dealer'
}

export function isPropertyPlatform(account, merchant) {
  return resolvePlatformType(account, merchant) === PROPERTY_PLATFORM
}

export function customersLabel(account, merchant) {
  return isPropertyPlatform(account, merchant) ? 'Residents' : 'Customers'
}

export function customerLabel(account, merchant) {
  return isPropertyPlatform(account, merchant) ? 'Resident' : 'Customer'
}

export function customersLabelLowercase(account, merchant) {
  return isPropertyPlatform(account, merchant) ? 'residents' : 'customers'
}

export function customerLabelWithParens(account, merchant) {
  return isPropertyPlatform(account, merchant) ? 'resident(s)' : 'customer(s)'
}
